import { BRANCH_CLUSTER_DROPDOWN_FIXTURES, BRANCH_DROPDOWN_FIXTURES, DEPARTMENT_DROPDOWN_FIXTURES, ROLE_DROPDOWN_FIXTURES, USER_FIXTURES } from './user.fixtures';

import { IMockHandler } from '@/mock/mock.handler.interface';
import { okDeleted, okList, okResults, okSingle } from '@/mock/mock.response.util';

const ID_ROUTE = /\/users\/([^/?]+)$/;
const ROLE_BY_USER = /\/role\/([^/?]+)$/;

export const userHandler: IMockHandler = {
    matches(req: any) {
        return req.url.includes('/users') ||
            req.url.includes('/role/') ||
            req.url.includes('/department/dropdown') ||
            req.url.includes('/branch/dropdown') ||
            req.url.includes('/branch-cluster/dropdown');
    },

    handle(req: any) {
        const { method, url } = req;
        const idMatch = url.match(ID_ROUTE);

        // ── Dropdowns first (most specific) ──────────────────────
        if (url.includes('/role/dropdown'))          return okResults(ROLE_DROPDOWN_FIXTURES);
        if (url.includes('/branch-cluster/dropdown')) return okResults(BRANCH_CLUSTER_DROPDOWN_FIXTURES);
        if (url.includes('/branch/dropdown'))         return okResults(BRANCH_DROPDOWN_FIXTURES);
        if (url.includes('/department/dropdown'))     return okResults(DEPARTMENT_DROPDOWN_FIXTURES);

        // ── GET /role/:userId ─────────────────────────────────────
        const roleMatch = url.match(ROLE_BY_USER);
        if (roleMatch) return okResults(ROLE_DROPDOWN_FIXTURES.slice(0, 2));

        // ── GET /users/:id ────────────────────────────────────────
        if (method === 'GET' && idMatch) {
            const found = USER_FIXTURES.find(u => String(u.id) === idMatch[1]);
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET /users ────────────────────────────────────────────
        if (method === 'GET' && url.endsWith('/users')) {
            const page = Number(req.params.get('page') ?? 0);
            const size = Number(req.params.get('size') ?? 10);
            return okList(USER_FIXTURES, page, size);
        }

        // ── POST /users ───────────────────────────────────────────
        if (method === 'POST' && url.endsWith('/users'))
            return okSingle({ ...req.body, id: Date.now() });

        // ── PUT /users/:id ────────────────────────────────────────
        if (method === 'PUT' && idMatch) {
            const base = USER_FIXTURES.find(u => String(u.id) === idMatch[1]);
            return okSingle({ ...base, ...req.body });
        }

        // ── DELETE /users/:id ─────────────────────────────────────
        if (method === 'DELETE' && idMatch) return okDeleted();

        throw new Error(`[UserHandler] unhandled: ${method} ${url}`);
    }
};
